export default __webpack_public_path__ + "static/media/picThiAnhDao.b6968fe2.png";